import { render, staticRenderFns } from "./JobProblemDetails.vue?vue&type=template&id=104b8aea&scoped=true&"
import script from "./JobProblemDetails.vue?vue&type=script&lang=js&"
export * from "./JobProblemDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobProblemDetails.vue?vue&type=style&index=0&id=104b8aea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104b8aea",
  null
  
)

export default component.exports